import React from 'react';
import Box from '@mui/material/Box';
import StarIcon from '@mui/icons-material/Star';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import useMediaQuery from '@mui/material/useMediaQuery';

const Rating = ({ activeStars }) => {
  const totalStars = 5;
  const largeScreen = useMediaQuery('(min-width:1024px)');
  return (
    <Box
      sx={{
        display: 'inline-flex',
        position: 'relative',
        cursor: 'pointer',
        textAlign: 'left',
        zIndex: 0,
      }}
    >
      {[...new Array(totalStars)].map((arr, index) => {
        const fontSize = largeScreen ? '1.6rem' : '0.5rem';
        return (
          <Box
            key={index}
            position="relative"
            sx={{
              cursor: 'pointer',
              color: index < activeStars ? 'orange' : 'inherit',
              fontSize: fontSize, // Adjust the size of the stars here
            }}
          >
            {index < activeStars && activeStars < index + 1 ? (
              <StarHalfIcon sx={{ fontSize: largeScreen ? 25 : 11 }}/>
            ) : index < activeStars ? (
              <StarIcon sx={{  fontSize: largeScreen ? 25 : 11 }}/>
            ) : (
              <StarBorderIcon sx={{  fontSize: largeScreen ? 25 : 11 }}/>
            )}
          </Box>
        );
      })}
      {' '}
      <span style={{ fontSize: largeScreen ? 25 : 11, paddingLeft: '3px' ,paddingTop: largeScreen ? 2 : 0, color:'black' }}>{activeStars}</span>
    </Box>
  );
};

export default function StarRating2({activeStars}) {

  return (
    <div>
      <Rating activeStars={activeStars} precision={0.5}/>
    </div>
  );
}
